import moment from "moment";
import { SettingService } from "@/services/nextshop/setting.service"

export default {
  methods: {
    multiplicationNum(val, num) {
      const _val = this.checkNumReplaceComma(val);
      return _val * num;
    },
    divisionNum(val, num) {
      const _val = this.checkNumReplaceComma(val);
      return Math.round(_val / num);
    },
    multiplicationThousand(val) {
      const _val = this.checkNumReplaceComma(val);

      return this.multiplicationNum(_val, 1000);
    },
    divisionThousand(val) {
      const _val = this.checkNumReplaceComma(val);
      return this.divisionNum(_val, 1000);
    },
    checkNumReplaceComma(val) {
      if (typeof val == "number") {
        return val;
      } else {
        if(val !== '' && val !== undefined){
          return parseInt((val.replace(/,/g, "")).replace(/\./g, ""));
        }
      }
      return 0
    },
    checkNumReplaceCommaOld(val) {
      if (typeof val == "number") {
        return val;
      } else {
        if(val !== '' && val !== undefined){
          return parseInt((val.replace(/,/g, "")).replace(/\./g, ""));
        }
      }
      return 0
    },
    formatMoney(val) {
      val = val
        .toString()
        .split(".")
        .join("");
      let output = "";
      while (val.length >= 3) {
        const last3Digits = val.slice(val.length - 3, val.length);
        val = val.slice(0, val.length - 3);
        output = "." + last3Digits + output;
      }
      if (val.length === 0) {
        output = output.slice(1, output.length);
      } else {
        output = val + output;
      }
      return output + " đ";
    },
    formatMoneyVND(val) {
      val = val
        .toString()
        .split(".")
        .join("");
      let output = "";
      while (val.length >= 3) {
        const last3Digits = val.slice(val.length - 3, val.length);
        val = val.slice(0, val.length - 3);
        output = "." + last3Digits + output;
      }
      if (val.length === 0) {
        output = output.slice(1, output.length);
      } else {
        output = val + output;
      }
      
      return output + " ₫";
    },
    formatMoneyNotUnit(val) {
      let isNegative = false
      if(val < 0) {
        val = -val
        isNegative = true
      }
      val = val
        .toString()
        .split(",")
        .join("");
      let output = "";
      while (val.length >= 3) {
        const last3Digits = val.slice(val.length - 3, val.length);
        val = val.slice(0, val.length - 3);
        output = "." + last3Digits + output;
      }
      if (val.length === 0) {
        output = output.slice(1, output.length);
      } else {
        output = val + output;
      }
      return isNegative? '-' +output : output ;
    },
    formatMoneyNotUnitExt(val) {
      val = val
        .toString()
        .split(",")
        .join("");
      let output = "";
      while (val.length >= 3) {
        const last3Digits = val.slice(val.length - 3, val.length);
        val = val.slice(0, val.length - 3);
        output = "." + last3Digits + output;
      }
      if (val.length === 0) {
        output = output.slice(1, output.length);
      } else {
        output = val + output;
      }
      return output;
    },
    formatNum(val) {
      if(val < 0) {
        return val
      }
      val = val.toString().split(".").join("");
      let output = "";
      while (val.length >= 3) {
        const last3Digits = val.slice(val.length - 3, val.length);
        val = val.slice(0, val.length - 3);
        output = "," + last3Digits + output;
      }
      if (val.length === 0) {
        output = output.slice(1, output.length);
      } else {
        output = val + output;
      }
      return output;
    },
    countTaxItem(priceItem, tax, discount) {
      let result = 0;
      if (tax.amount > 0) {
        return tax.amount;
      } else {
        let result_discount = 0;
        const perThousand = discount.perThousand;
        const amount = discount.amount;
        if (amount > 0) {
          result_discount = amount;
        } else {
          result_discount = ((perThousand / 10) * priceItem) / 100;
        }
        result = ((tax.perThousand / 10) * (priceItem - result_discount)) / 100; 
      }
      return result;
    },
    countDiscountItem(priceItem, discount) {
      let result = 0;

      const perThousand = discount.perThousand;
      const amount = discount.amount;
      if (amount > 0) {
        result = amount;
      } else {
        result = ((perThousand / 10) * priceItem) / 100;
      }

      return result;
    },
    timeFormatStatus: function (date) {
      return moment(date).format("HH:mm, DD/MM/yy");
    },
    timeFormatDate: function (date) {
      if (date) {
        return moment(date).format("DD/MM/yy");
      } else {
        return ''
      }
    },
    timeFormatTime: function (date) {
      return moment(date).format("HH:mm");
    },
    sleep(ms) {
      return new Promise((resolve) => {
        setTimeout(resolve, ms);
      });
    },
    allowNumbersOnly($event) {
      if (
        !["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"].includes(
          $event.key
        ) &&
        $event.keyCode !== 8 && $event.location === 0 && $event.keyCode !== 109
      ) {
        $event.preventDefault();
      }
    },
    allowNumbersOnlyAndMoveKey($event) {
      if(![
        "0","1","2","3","4","5","6","7","8","9",
        "ArrowUp","ArrowDown","ArrowLeft","ArrowRight",
        "Backspace","Enter"
      ].includes($event.key)) {
        $event.preventDefault()
      }
      if($event.key == "Enter") {
        $event.target.blur()
      }
    },
    getAmountCustomerPay(params) {
      let val = 0;
      params.map(function (item) {
        val += parseInt(item.amount);
      });
      return val;
    },
    inputOrdersData(params) {
      const _this = this;
      //lineItem
      params.lineItem.map(function (item, index) {
        //const unitPrice = item.unitPrice;
        const unitPrice = item.amount_init;
        const quantity = item.quantity
        const totalAmount = item.totalAmount;
        const amountInit = item.amount_init;
        
        params.lineItem[index].unitPrice = _this.multiplicationThousand(unitPrice);
        params.lineItem[index].amount = _this.multiplicationThousand(quantity * unitPrice)
        params.lineItem[index].amount_init = _this.multiplicationThousand(amountInit);
        params.lineItem[index].totalAmount = _this.multiplicationThousand(totalAmount);
        if (
          params.lineItem[index].discount &&
          params.lineItem[index].discount[0] &&
          params.lineItem[index].discount[0].amount > 0
        ) {
          const discount_amount = params.lineItem[index].discount[0].amount;
          params.lineItem[index].discount[0].amount = quantity * _this.multiplicationThousand(discount_amount);
        }
        if (
          params.lineItem[index].tax &&
          params.lineItem[index].tax[0] &&
          params.lineItem[index].tax[0].amount > 0
        ) {
          const tax_amount = params.lineItem[index].tax[0].amount;
          params.lineItem[index].tax[0].amount = _this.multiplicationThousand(tax_amount);
        }
        if(params.lineItem[index].seriesNoTmp){
          if(params.lineItem[index].seriesNoTmp.length == 0){
            params.lineItem[index].lineItemOtherInfo.seriesNo = null
          }else{
            params.lineItem[index].lineItemOtherInfo.seriesNo = JSON.stringify(params.lineItem[index].seriesNoTmp);
          }
        }
        if(params.lineItem[index].lineItemOtherInfo.seriesNo && params.lineItem[index].lineItemOtherInfo.seriesNo.length === 0){
          params.lineItem[index].lineItemOtherInfo.seriesNo = null
        }

      });
      
      //addFees
      params.addFees.map(function (item, index) {
        if (item.key == "TAX_ALL") {
          const tax_all = !isNaN(params.addFees[index].amount) ? params.addFees[index].amount : 0;
          params.addFees[index].amount = _this.multiplicationThousand(tax_all);
        }
        if (item.key == "DISCOUNT_ALL") {
          const discount_all = !isNaN(params.addFees[index].amount !== null) ? params.addFees[index].amount : 0;
          params.addFees[index].amount = _this.multiplicationThousand(
            discount_all
          );
        }
        if (item.key == "OTHER_FEE") {
          const other_fee = !isNaN(params.addFees[index].amount !== null) ? params.addFees[index].amount : 0;
          params.addFees[index].amount = _this.multiplicationThousand(
            other_fee
          );
        }

        if (item.key == "SHIPPING_FEE") {
          const shipping_fee = !isNaN(params.addFees[index].amount !== null) ? params.addFees[index].amount : 0;
          params.addFees[index].amount = _this.multiplicationThousand(
            shipping_fee
          );
        }
      })
      
      let splitLineItemLoHsd = []
      let spliceItem = []
      params.lineItem.map((item) => {
        const tmpItem = _this.splitLineItemLoHsd(item)
        if(tmpItem.length > 0){
          splitLineItemLoHsd.push(...tmpItem)
          spliceItem.push(item.lineItemId)
        }
      })
      if(spliceItem.length > 0){
        spliceItem.map((item) => {
          const getIndex = params.lineItem.findIndex((val) => val.lineItemId === item)
          if(getIndex != -1){
            params.lineItem.splice(getIndex, 1)
          }
        })
        if(splitLineItemLoHsd.length > 0){
          params.lineItem.push(...splitLineItemLoHsd)
        }
      }

      //Giao hang sau
      if(params.isDiliveryLast){
        params.dloInfo.shippingFee = (params.dloInfo.shippingFee) ? _this.multiplicationThousand(params.dloInfo.shippingFee) : 0
        if(params.dloInfo.targetService == 'DELIVERY_PRIVATE_SHIPPER'){
          params.dloInfo.deliveryServicePack = null
        }
        params.dloInfo.cod = _this.multiplicationThousand(params.dloInfo.cod)
      }else{
        if(params.dloInfo){
          delete params['dloInfo']
        }
      }

      return params
    },
    outputOrdersData(params) {
      const _this = this;
      //lineItem
      params.lineItem.map(function (item, index) {
        const unitPrice = item.unitPrice;
        const quantity = item.quantity;
        const totalAmount = item.totalAmount;
        params.lineItem[index].unitPrice = _this.divisionThousand(unitPrice);
        params.lineItem[index].amount = _this.divisionThousand(quantity * unitPrice)

        params.lineItem[index].totalAmount = _this.divisionThousand(totalAmount);

        if (
          params.lineItem[index].discount &&
          params.lineItem[index].discount[0] &&
          params.lineItem[index].discount[0].amount > 0
        ) {
          const discount_amount = params.lineItem[index].discount[0].amount;
          params.lineItem[index].discount[0].amount = _this.divisionThousand(discount_amount) / quantity;
        }
        if (
          params.lineItem[index].tax &&
          params.lineItem[index].tax[0] &&
          params.lineItem[index].tax[0].amount > 0
        ) {
          const tax_amount = params.lineItem[index].tax[0].amount;
          params.lineItem[index].tax[0].amount = _this.divisionThousand(tax_amount);
        }

        if(params.lineItem[index].lineItemOtherInfo && params.lineItem[index].lineItemOtherInfo.seriesNo){
          params.lineItem[index].lineItemOtherInfo.seriesNo = (params.lineItem[index].lineItemOtherInfo.seriesNo) ? JSON.parse(params.lineItem[index].lineItemOtherInfo.seriesNo) : []
        }else{
          params.lineItem[index].lineItemOtherInfo.seriesNo = []
        }

        params.lineItem[index]._showDetails = true

      });
      //addFees
      params.lineItemFinalizing.addedFee.map(function (item, index) {
        if (item.key == "TAX_ALL") {
          const tax_all = params.lineItemFinalizing.addedFee[index].amount;
          params.lineItemFinalizing.addedFee[
            index
            ].amount = _this.divisionThousand(tax_all);
        }
        if (item.key == "DISCOUNT_ALL") {
          const discount_all = params.lineItemFinalizing.addedFee[index].amount;
          params.lineItemFinalizing.addedFee[
            index
            ].amount = _this.divisionThousand(discount_all);
        }
        if (item.key == "OTHER_FEE") {
          const other_fee = params.lineItemFinalizing.addedFee[index].amount;
          params.lineItemFinalizing.addedFee[
            index
            ].amount = _this.divisionThousand(other_fee);
        }
        if (item.key == "SHIPPING_FEE") {
          const shipping_fee = params.lineItemFinalizing.addedFee[index].amount;
          params.lineItemFinalizing.addedFee[index].amount = _this.divisionThousand(shipping_fee);
        }
      });
      //outcomes
      params.outcomes.map(function (item, index) {
        if (item.cat == "NSH_PAYMENT") {
          const outcomes_amount = params.outcomes[index].params.amount;
          params.outcomes[index].params.amount = _this.divisionThousand(
            outcomes_amount
          );
        }
      });

      const lineItemFinalizing_netSubTotal =
        params.lineItemFinalizing.netSubTotal;
      const lineItemFinalizing_finalAmount =
        params.lineItemFinalizing.finalAmount;
      params.lineItemFinalizing.netSubTotal = _this.divisionThousand(
        lineItemFinalizing_netSubTotal
      );
      params.lineItemFinalizing.finalAmount = _this.divisionThousand(
        lineItemFinalizing_finalAmount
      );

      const lineItemAgg_grossSubTotal = params.lineItemAgg.grossSubTotal;
      const lineItemAgg_netSubTotal = params.lineItemAgg.netSubTotal;
      params.lineItemAgg.grossSubTotal = _this.divisionThousand(
        lineItemAgg_grossSubTotal
      );
      params.lineItemAgg.netSubTotal = _this.divisionThousand(
        lineItemAgg_netSubTotal
      );

      //Giao hang sau
      if(params.isDiliveryLast){
        params.dloInfo.shippingFee = (params.dloInfo.shippingFee) ? _this.divisionThousand(params.dloInfo.shippingFee) : 0
      }

      return params;
    },

    getNameLocation(idLocation) {
      const listLocation = JSON.parse(
        localStorage.getItem("auth.locations")
      );
      const locationMerchant = listLocation.map((e) => e.id);
      const indexVal = locationMerchant.findIndex((e) => e === idLocation);
      const result = listLocation[indexVal] ? listLocation[indexVal].name : '---';
      return result;
    },
    
    async checkConfigInventory () {
      const response = await SettingService.getDataMerchant();
			let enableInventory = false
			if(response.success){
				enableInventory = response.data.merchant.enableInventory
			}
			if(!enableInventory){
        this.$router.push('/inventory-active')
			}
    },

    splitLineItemLoHsd(item){
      let lineItemTmp = []
      if(item.useProductBatch){
        if(item.batchTmp && item.batchTmp.length > 0){
          item.batchTmp.map(async(val, index)=>{
            lineItemTmp[index] = JSON.parse(JSON.stringify(item))
            const batchCodeItem = {
                "batchCode": val.batchCode,
                "quantity": val.quantityVal,
                "manufactureDate": val.manufactureDate,
                "expirationDate": val.expirationDate
              }
            lineItemTmp[index].lineItemOtherInfo.productBatch = JSON.stringify(batchCodeItem)
            lineItemTmp[index].totalAmount = val.quantityVal * (lineItemTmp[index].totalAmount / lineItemTmp[index].quantity)
            lineItemTmp[index].amount = val.quantityVal * (lineItemTmp[index].amount / lineItemTmp[index].quantity)
            lineItemTmp[index].quantity = val.quantityVal
          })
        }
      }
      return lineItemTmp
    },

    mergeLineItemLoHsd(lineItem){
      
      let lineItemTmp = []
      
      lineItem.map(function (item) {
        if(item.lineItemOtherInfo.productBatch && item.lineItemOtherInfo.productBatch.length > 0){
          item.lineItemOtherInfo.productBatch = JSON.parse(item.lineItemOtherInfo.productBatch)
          
          let productBatch = item.lineItemOtherInfo.productBatch
          productBatch.quantityVal = productBatch.quantity
         
          if(lineItemTmp.length == 0){  
            lineItemTmp.push(item)
            lineItemTmp[0].lineItemOtherInfo.arrProductBatch = []
            lineItemTmp[0].batchTmp = []
            lineItemTmp[0].lineItemOtherInfo.arrProductBatch.push(productBatch)
            lineItemTmp[0].batchTmp.push(productBatch)
            lineItemTmp[0].useProductBatch = true
          }else{
            const getIndex = lineItemTmp.findIndex((val) => val.lineItemId === item.lineItemId)
            if(getIndex === -1){
              lineItemTmp.push(item)
              const _key = (lineItemTmp.length) - 1
              lineItemTmp[_key].lineItemOtherInfo.arrProductBatch = []
              lineItemTmp[_key].batchTmp = []
              lineItemTmp[_key].lineItemOtherInfo.arrProductBatch.push(productBatch)
              lineItemTmp[_key].batchTmp.push(productBatch)
              lineItemTmp[_key].useProductBatch = true
            }else{
              lineItemTmp[getIndex].lineItemOtherInfo.arrProductBatch.push(productBatch)
              lineItemTmp[getIndex].batchTmp.push(productBatch)
              lineItemTmp[getIndex].quantity += parseInt(item.quantity)
              lineItemTmp[getIndex].amount += parseInt(item.amount)
              lineItemTmp[getIndex].totalAmount += parseInt(item.totalAmount)
              lineItemTmp[getIndex].useProductBatch = true
            }
          }
        }else{
          lineItemTmp.push(item)
        }
      })
      return lineItemTmp
    },

    getDateToday(){
      return moment().format('DD/MM/YYYY')
    },

    convertDateItem(time){
      const timeDate = new Date(Date.parse(time))
      return timeDate.toLocaleDateString()
    },

    convertIntDateItem(time){
      return moment(time).format('YYYYMMDD')
    },

    getDateToday00Hour(){
      return moment().format('YYYY-MM-DD') + 'T00:00:00+07:00'
    },

    getNumber(val){
      return  Number(this.checkNumReplaceComma(val))
    },
    
    allowNumbersOnlyFloat($event) {
      if (!["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "."].includes($event.key) && $event.keyCode !== 8 && $event.location === 0 && $event.keyCode !== 109) {
        $event.preventDefault();
      }
    },

    formatInputQuantityFloat(val){
      if (val === '') return 0
      
      if(isNaN(val)){
        val = val.replace(/[^0-9\.]/g, '')
        if(val.split('.').length > 2){
          val = val.replace(/\.+$/, '')
        }
      }

      if(val.split('.').length > 0){
        const arrVal = val.split('.')
        arrVal[0] = parseInt(arrVal[0])
        val = arrVal.join('.')
      }
      
      return val
    },

    getPathImage(path, name) {
      try {
				return require(`@/${path}${name}.svg`)
			} catch (error) {
				return require(`@/assets/menu-icons/fa-house.svg`)
			}
		},
    
    getPaymentParam({payGateway, payMethod}) {
      switch (true) {
        case (payMethod == "CASH") :
          return {
            paymentMethod: "CASH",
            paymentGateway: "CASH",
            note: "Tiền mặt",
            imgUrl: require("@/assets/images/Payment_Cash.svg"),
            active: false,
            amount: 0,
            status: "SUCCESS",
          }
        case (payMethod == "BANK_TRANSFER"):
          return {
            paymentMethod: "BANK_TRANSFER",
            paymentGateway: "BANK",
            note: "Chuyển khoản",
            imgUrl: require("@/assets/images/Payment_Transfer.svg"),
            active: false,
            amount: 0,
            status: "SUCCESS",
          }
        case (payMethod == "SWIPE" && payGateway == "MPOS"):
          return {
            paymentMethod: "SWIPE",
            paymentGateway: "MPOS",
            note: "Mpos",
            imgUrl: require("@/assets/images/Payment_Mpos.svg"),
            active: false,
            amount: 0,
            status: "SUCCESS",
          }
        case (payMethod == "SWIPE" && payGateway == "OTHER"):
          return {
            paymentMethod: "ONLINE",
            paymentGateway: "OTHER",
            note: "Quẹt thẻ",
            imgUrl: require("@/assets/images/credit.svg"),
            active: false,
            amount: 0,
            status: "SUCCESS",
          }
        case (payMethod == "COD"):
          return {
            paymentMethod: "COD",
            paymentGateway: "COD",
            note: "COD",
            imgUrl: require("@/assets/images/cod.svg"),
            active: false,
            amount: 0,
            status: "PROCESSING",
          }
        default:
          return {
            paymentMethod: "CASH",
            paymentGateway: "CASH",
            note: "Tiền mặt",
            imgUrl: require("@/assets/images/Payment_Cash.svg"),
            active: false,
            amount: 0,
            status: "SUCCESS",
          }
      }
    },
    getPickerOptions() {
      return {
        shortcuts: [
          {
            text: "Hôm nay",
            onClick(picker) {
              const end = new Date();
              const start = moment().startOf("day")._d;
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "Tuần trước",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "Tháng trước",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "3 tháng trước",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "Năm trước",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "Đầu tuần đến nay",
            onClick(picker) {
              const end = new Date();
              const start = moment().startOf("week")._d;
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "Đầu tháng đến nay",
            onClick(picker) {
              const end = new Date();
              const start = moment().startOf("month")._d;
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "Đầu năm đến nay",
            onClick(picker) {
              const end = new Date();
              const start = moment().startOf("year")._d;
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      }
    },
    formatQuantity(num) {
      const data = num.toString().split('.')
      let val = data[0].toString().split(",").join('');
      const pc = data.length == 2 ? data[1] : ''
     
      let output = '';
      while (val.length >= 3) {
        const last3Digits = val.slice(val.length - 3, val.length);
        val = val.slice(0, val.length - 3);
        output = '.' + last3Digits + output;
      }
      if (val.length === 0) {
        output = output.slice(1, output.length);
      } else {
        output = val + output;
      }
      if(pc != ''){
        return output + ',' + pc
      }else{
        return output
      }
    },
  }
};
